export const RESPONSIVE_CONTAINER_NAME = 'kne-responsive';

export const RESPONSIVE_CONTAINER_CLASS = 'kne-responsive-container';

export const RESPONSIVE_BOUNDARY_CLASS = 'kne-responsive-boundary';

export const RESPONSIVE_SCROLL_CLASS = 'kne-responsive-scroll';

export const RESPONSIVE_TARGET_CLASSES = {
  container: RESPONSIVE_CONTAINER_CLASS,
  boundary: RESPONSIVE_BOUNDARY_CLASS,
  scroll: RESPONSIVE_SCROLL_CLASS
};
